import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
// import TopScroll from 'vue-top-scroll';
// import VuePipeline from 'vue-pipeline';

import preventReClick from '@/js/v-preventReClick';
// import resize from '@/js/v-resize'
Vue.use(preventReClick); // Prevent frequent click

// Scroll to Top
// Vue.component('top-scroll', TopScroll);
// import EasyGoTop from 'easy-go-top';
// Vue.use(EasyGoTop)

// Guide for users
import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

// alibaba iconfont
import '@/assets/iconfont/iconfont.js';

import D3Chart from '@/components/charts/D3Chart.vue';
Vue.component('d3-chart', D3Chart);


// Vue.use(VuePipeline);
// Vue.use(resize); // iframe resizer (https://github.com/davidjbradshaw/iframe-resizer/issues/513)

// import $ from 'jquery';

// Ensures all pending requests are cancelled on route change
// router.beforeEach((to, from, next) => {
//   store.commit('clearToken'); // 取消请求
//   next();
// })

// 创建百度统计js
// eslint-disable-next-line
// const _hmt = _hmt || [];
// // eslint-disable-next-line
// window._hmt = _hmt; // 修改为window 全局变量
// (function () {
//   const hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?35a51e8d86cc9884e5467b3d238adb38";
//   const s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();
router.beforeEach(async (to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      // eslint-disable-next-line
      window._hmt.push(['_trackPageview', to.fullPath]);
    }
  }
  // 路由发生变化，修改页面 title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});


// Return to the top of the page after route jump
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0); // Return to the top of the page after route jump

  // 创建百度统计js
  // setTimeout(() => {
  //   var _hmt = _hmt || [];
  //   (function () {
  //     var hm = document.createElement("script");
  //     hm.src = "https://hm.baidu.com/hm.js?35a51e8d86cc9884e5467b3d238adb38";
  //     var s = document.getElementsByTagName("script")[0];
  //     s.parentNode.insertBefore(hm, s);
  //   })();
  // }, 0);
});

Vue.config.productionTip = false;
// window.$ = $

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
